import { Handle, NodeProps, Position } from 'reactflow';
import { Layers, Eye } from 'lucide-react';
import { PipelineNodeData } from '../../types/pipeline';

export default function UnionNode({ data, selected }: NodeProps<PipelineNodeData>) {
  return (
    <div
      className={`rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? 'border-teal-500 ring-2 ring-teal-200' : 'border-teal-200'
      }`}
      title="Click to preview union data"
    >
      <Handle type="target" position={Position.Left} id="input-1" className="!bg-teal-500 !-top-2" />
      <Handle type="target" position={Position.Left} id="input-2" className="!bg-teal-500 !top-1/3" />
      <Handle type="target" position={Position.Left} id="input-3" className="!bg-teal-500 !top-2/3" />
      <Handle type="target" position={Position.Left} id="input-4" className="!bg-teal-500 !-bottom-2" />
      <Handle type="source" position={Position.Right} className="!bg-teal-500" />

      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-teal-700">
          <Layers className="h-4 w-4" />
          <span>{data.label}</span>
        </div>

        {/* Preview indicator - shows when selected */}
        {selected && (
          <Eye className="h-3.5 w-3.5 text-teal-500 opacity-70" />
        )}
      </div>

      {data.description && (
        <p className="mt-1 text-xs text-slate-500">{data.description}</p>
      )}

      {/* Preview hint when selected */}
      {selected && (
        <p className="mt-1 text-xs text-teal-600 font-medium">
          Preview active
        </p>
      )}
    </div>
  );
}
